import { CardImportFileContainer } from "./CardImportFile.styled";
import {Text} from "../UI/generalLayout/Layout.styled";
import iconUpload from "../../assets/imgs/iconUploadFile.svg";
interface ICardImportFile {
  onClick: () => void;
  references: any;
}

const CardImportFile = ({onClick, references}: ICardImportFile) => {
  return (
    <>
      <CardImportFileContainer htmlFor="uploadFile" colorBack="" width={390}>
        <img src={iconUpload} style={{marginRight: "3px"}} alt="" />
        <Text color="#B91C1C">Clique aqui para adicionar o arquivo </Text>
        <Text color="#B91C1C" bold={true} style={{marginLeft: "3px"}}>.csv</Text>
      </CardImportFileContainer>
      <input name="uploadFile" type="file" ref={references} onChange={onClick} accept="text/csv" id="uploadFile" style={{display: "none"}} />
      </>
  );
};

export default CardImportFile;
